import { Component, Input, Output, EventEmitter } from '@angular/core';

import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-patient-interaction-locations-explainer',
    templateUrl: './patient-interaction-locations-explainer.component.html',
    styleUrls: ['./patient-interaction-locations-explainer.component.scss'],
    imports: [MatIcon]
})
export class PatientInteractionLocationsExplainerComponent {
  @Input() expanded = true;

  @Output() expandOrCollapse = new EventEmitter<boolean>();

  onExpandOrCollapseClick(expanded: boolean) {
    this.expanded = expanded;
    this.expandOrCollapse.emit(expanded);
  }
}
